// extracted by mini-css-extract-plugin
module.exports = {"dateDottedLine":"dsof_BBW"};